import React from 'react';
// import pineappleIcon from "../../assets/images/logo.svg";
const pineappleIcon = "";
const ImageWithAltImage = ({ src, alt = "icon" }) => {
    return (
        <img className={`${src ? '' : 'alt-img'}`} src={!!src ? src : pineappleIcon} style={!!src ? {} : { filter: 'grayscale(0%)', opacity: '.1', padding: '3px' }} />
  );
};

export default ImageWithAltImage;